
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './Redux/store'; 
import App from './App';
import { LOGIN_SUCCESS } from './Redux/actions/auth';

// Retrieve user from localStorage and dispatch login action if user is stored
const storedUser = localStorage.getItem('user');
if (storedUser) {
  store.dispatch({
    type: LOGIN_SUCCESS,
    payload: JSON.parse(storedUser),
  });
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
     
      <BrowserRouter>
        <App />
      </BrowserRouter>
     
    </Provider>
  </React.StrictMode>
);














//import React from "react";
//import ReactDOM from "react-dom";
//import "./index.css";
//import App from "./App";
//import { BrowserRouter as Router } from "react-router-dom";
//import { Provider } from "react-redux";
//import { store } from "./Redux/store";
//import { LOGIN_SUCCESS } from "./Redux/actions/auth";

//const storedUser = localStorage.getItem("user");
//if (storedUser) {

 // store.dispatch({
 //   type: LOGIN_SUCCESS,
 //   payload: JSON.parse(storedUser),
//  });
//}

//ReactDOM.render(
 // <React.StrictMode>
  //  <Provider store={store}>
  //    <Router>
 //       <App />
 //     </Router>
//    </Provider>
 // </React.StrictMode>,
//  document.getElementById("root")
//);
